import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  const [quote, setQuote] = useState(null);

  const quotes = [
    {
      emoji: "🚫",
      title: "This is not the page you're looking for.",
      subtitle: "Jedi mind tricks won't help… try the homepage instead.",
      btn: "Use the Force",
    },
    {
      emoji: "💥",
      title: "404: This page will not be back.",
      subtitle: "Hasta la vista, URL.",
      btn: "Back to Safety",
    },
    {
      emoji: "🕶",
      title: "There is no page.",
      subtitle:
        "You can take the blue link or the red link… but neither leads here.",
      btn: "Wake Up, Neo",
    },
    {
      emoji: "🍫",
      title: "Life is like a box of 404s…",
      subtitle: "You never know what page you're gonna get.",
      btn: "Run, Forrest, Run!",
    },
    {
      emoji: "🕴",
      title: "I'm gonna make you a 404 you can't refuse.",
      subtitle: "But maybe you'd prefer a working page instead?",
      btn: "Take the Offer",
    },
    {
      emoji: "⚡",
      title: "Great Scott! The page has disappeared!",
      subtitle: "Looks like we went 88 mph in the wrong direction.",
      btn: "Go Back in Time",
    },
  ];

  useEffect(() => {
    const randomQuote = quotes[Math.floor(Math.random() * quotes.length)];

    setQuote(randomQuote);
  }, []);

  if (!quote) return null;

  return (
    <div className="not-found-container">
      <div className="not-found-card">
        <div className="not-found-badge">{quote.emoji} 404 Not Found</div>
        <h1 className="not-found-title">{quote.title}</h1>
        <p className="not-found-subtitle">{quote.subtitle}</p>
        <div className="not-found-actions">
          <button
            className="not-found-btn"
            onClick={() => navigate("/dashboard")}
          >
            {quote.emoji} {quote.btn}
          </button>
          <button className="not-found-link" onClick={() => navigate(-1)}>
            ← Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
